module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-label-aling"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('output', {
    staticClass: "range-output"
  }, [_vm._v(_vm._s(_vm.value))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-61995642!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Range.vue
 ** module id = 844
 ** module chunks = 1
 **/